import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ApartadoComponent } from './apartado/lista.component';
import { CajaComponent } from './caja/lista.component';
import { CompraComponent } from './compra/lista.component';
import { TraspasoComponent } from './traspaso/lista.component';
import { VentaComponent } from './venta/lista.component';

import { AuthGuard } from '../../auth-guard.service';

const routes: Routes = [
  { path: 'reportes/detallado', redirectTo: '/reporte/detallado/detallado', pathMatch: 'full' },
  {
    path: 'reportes/detallado',
    children: [
      { path: 'apartado', component: ApartadoComponent },
      { path: 'caja', component: CajaComponent },
      { path: 'compra', component: CompraComponent },
      { path: 'traspaso', component: TraspasoComponent },
      { path: 'venta', component: VentaComponent }
    ],
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ReporteDetalladoRoutingModule { }

